import { trackByKey } from '@aw/shared/utilities';

import { ReferenceData } from '../models/entities/reference-data.model';

export const refDataValueAccessor = (item: ReferenceData): string => item.key;
export const trackRefData = trackByKey<ReferenceData>();
